import { getSessionState, setSessionState } from '~/modules/utils';
import type { RootState } from '~/state/reducers';

const STORAGE_KEY = 'globalState';

/**
 * Only UI/auth slices survive a reload. Server data lives in RTK Query and is refetched, and
 * list view state lives in the URL, so neither is stored here.
 */
const PERSISTED_KEYS = ['notification', 'user', 'actingAs'] as const;

export type PersistedState = Pick<RootState, (typeof PERSISTED_KEYS)[number]>;

export const pickPersistedState = (state: RootState): PersistedState => ({
  notification: state.notification,
  user: state.user,
  actingAs: state.actingAs,
});

/** Picks the persisted keys explicitly so a snapshot from an older build (nav, mls) is dropped. */
export const loadPersistedState = (): Partial<PersistedState> | undefined => {
  const raw = getSessionState(STORAGE_KEY) as Partial<PersistedState> | undefined;

  if (!raw) {
    return undefined;
  }

  return { notification: raw.notification, user: raw.user, actingAs: raw.actingAs };
};

export const savePersistedState = (state: RootState) =>
  setSessionState(STORAGE_KEY, pickPersistedState(state));
